import { useContext } from "react";
import svgLeft from "../assets/left-bottom.svg";
import svgRight from "../assets/right-bottom.svg";
import { GraphContext } from "./data";
import { SubTypeColor } from "./model";

export const CrPanel = (props: { side: "left" | "right" }) => {
  const { colorList, sharedData, setSharedData } = useContext(GraphContext);
  if (props.side === "right") {
    return (
      <div className={"panel-right"}>
        <img src={svgRight} alt="" />
      </div>
    );
  }
  const onClick = (color: SubTypeColor) => {
    setSharedData({
      source: sharedData.source,
      subType: sharedData.subType === color.subType ? "" : color.subType,
    });
  };

  return (
    <div className="panel-left color-panel">
      {colorList
        .filter((color: SubTypeColor) => color.subType)
        .slice(0, 10)
        .map((color: SubTypeColor, index: number) => (
          <div
            key={index}
            className={
              "color-bar" + (!sharedData.subType
                ? ""
                : sharedData.subType === color.subType
                ? " active"
                : " dark")
            }
            onClick={() => {
              onClick(color);
            }}
          >
            <span
              className="item"
              style={{ backgroundColor: color.color }}
            ></span>
            {color.subType} ({color.count})
          </div>
        ))}
    </div>
  );
};
